/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_No_HrInputs */

const en_ui_te_no_hr = /** @type {(inputs: Ui_Te_No_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This session has no heart rate data`)
};

const de_ui_te_no_hr = /** @type {(inputs: Ui_Te_No_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Einheit hat keine Herzfrequenzdaten`)
};

/**
* | output |
* | --- |
* | "This session has no heart rate data" |
*
* @param {Ui_Te_No_HrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_no_hr = /** @type {((inputs?: Ui_Te_No_HrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_No_HrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_no_hr(inputs)
	return de_ui_te_no_hr(inputs)
});